import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";

const ClearDataDialog = ({ open, onCancel, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="confirm-dialog-title"
    aria-describedby="confirm-dialog-description"
  >
    <DialogTitle id="confirm-dialog-title" sx={{ color: "warning.main" }}>
      Clear Existing OSM Data?
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="confirm-dialog-description">
        This will remove all previously collected OSM data from your account before fetching new data.
        Any unsaved progress will be lost.
        <br />
        <br />
        <strong>Are you sure you want to proceed?</strong>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="warning" variant="contained" autoFocus>
        Yes, Clear Data and Fetch
      </Button>
    </DialogActions>
  </Dialog>
);

export default ClearDataDialog;
